<template>
    <div>
        <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>系统管理</el-breadcrumb-item>
            <el-breadcrumb-item>大屏配置</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card :body-style="{ padding: '10px' }">
            <!--搜索与添加区域-->
            <el-row :gutter="20" style="margin-bottom: 10px;">
                <el-col :span="24">
                    <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加大屏配置</el-button>
                    <el-button type="warning" icon="el-icon-refresh" :loading="pushLoading" @click="handlePushUrl">更新地址</el-button>
                </el-col>
            </el-row>
            <!--搜索与添加区域-->
            <!--列表区域-->
            <el-table v-loading="loading" :data="configList" style="width: 100%" stripe height="700">
                <el-table-column label="ID" type="index" width="100"></el-table-column>
                <el-table-column label="配置键" prop="configKey" width="200"></el-table-column>
                <el-table-column label="配置值" prop="configValue" min-width="300" show-overflow-tooltip></el-table-column>
                <el-table-column label="类型" prop="configType" width="160">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.configType === '1' || scope.row.configType === 1">小时兜底值</el-tag>
                        <el-tag v-else-if="scope.row.configType === '2' || scope.row.configType === 2" type="success">大屏地址</el-tag>
                        <el-tag v-else-if="scope.row.configType === '3' || scope.row.configType === 3" type="warning">倍数配置</el-tag>
                        <span v-else>{{ scope.row.configType }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="success" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--列表区域-->
            <!--添加/编辑对话框-->
            <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="40%" :close-on-click-modal="false" @close="handleDialogClose">
                <el-form :model="form" :rules="formRules" ref="configForm" label-width="100px">
                    <el-form-item label="配置键" prop="configKey">
                        <el-input v-model="form.configKey" placeholder="如 url、zxbs、dkbs、0~23"></el-input>
                    </el-form-item>
                    <el-form-item label="配置值" prop="configValue">
                        <el-input type="textarea" :rows="3" v-model="form.configValue" placeholder="如 https://xxx"></el-input>
                    </el-form-item>
                    <el-form-item label="类型" prop="configType">
                        <el-select v-model="form.configType" placeholder="请选择类型" style="width: 100%">
                            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
                </span>
            </el-dialog>
        </el-card>
    </div>
</template>

<script>
const RESERVED_KEYS = ['zxbs', 'dkbs', 'url',
  ...Array.from({ length: 24 }, (_, i) => String(i))]

export default {
  name: 'DashboardConfig',
  data() {
    return {
      configList: [],
      loading: false,
      dialogVisible: false,
      dialogTitle: '',
      submitLoading: false,
      pushLoading: false,
      typeOptions: [
        { value: '1', label: '小时兜底值' },
        { value: '2', label: '大屏地址' },
        { value: '3', label: '倍数配置' }
      ],
      form: {
        id: null,
        configKey: null,
        configValue: null,
        configType: null
      },
      formRules: {
        configKey: [
          { required: true, message: '请输入配置键', trigger: 'blur' }
        ],
        configValue: [
          { required: true, message: '请输入配置值', trigger: 'blur' }
        ],
        configType: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      this.loading = true
      this.$http.get('/dssh/config/list')
        .then(response => {
          const data = response.data
          if (data.code === 200) {
            const payload = data.data || {}
            this.configList = payload.list || []
          } else {
            this.$message.error(data.msg || '获取大屏配置列表失败')
          }
        })
        .catch(error => {
          console.error('获取大屏配置列表失败:', error)
          this.$message.error('获取大屏配置列表失败，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 新增
    handleAdd() {
      this.dialogTitle = '添加大屏配置'
      this.dialogVisible = true
      this.form = {
        id: null,
        configKey: null,
        configValue: null,
        configType: null
      }
    },

    // 更新大屏地址（推送给大屏端）
    handlePushUrl() {
      this.$confirm('确定要将大屏地址推送到所有大屏端吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.pushLoading = true
          this.$http.get('/dssh/pushUrl')
            .then(response => {
              if (response.data.code === 200) {
                this.$message.success('地址推送成功')
              } else {
                this.$message.error(response.data.msg || '推送失败')
              }
            })
            .catch(error => {
              console.error('推送大屏地址失败:', error)
              this.$message.error('推送大屏地址失败，请稍后重试')
            })
            .finally(() => {
              this.pushLoading = false
            })
        })
        .catch(() => {
          // 用户取消
        })
    },

    // 编辑（拉详情回填，确保拿到最新值）
    handleEdit(row) {
      this.dialogTitle = '编辑大屏配置'
      this.dialogVisible = true
      this.form = {
        id: row.id,
        configKey: row.configKey,
        configValue: row.configValue,
        configType: row.configType
      }
      this.$http.get('/dssh/config/detail', { params: { id: row.id } })
        .then(response => {
          const data = response.data
          if (data.code === 200 && data.data) {
            this.form.configKey = data.data.configKey
            this.form.configValue = data.data.configValue
            this.form.configType = data.data.configType
          }
        })
        .catch(error => {
          console.error('获取大屏配置详情失败:', error)
        })
    },

    // 删除（固定 key 二次警告）
    handleDelete(row) {
      const isReserved = RESERVED_KEYS.includes(row.configKey)
      const message = isReserved
        ? `【${row.configKey}】为大屏端兜底依赖的固定 Key，删除将导致大屏异常！是否继续？`
        : '确定要删除该配置吗？'
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: isReserved ? 'error' : 'warning'
      })
        .then(() => {
          this.loading = true
          this.$http.post('/dssh/config/delete', null, { params: { id: row.id } })
            .then(response => {
              if (response.data.code === 200) {
                this.$message.success('删除成功')
                this.getList()
              } else {
                this.$message.error(response.data.msg || '删除失败')
              }
            })
            .catch(error => {
              console.error('删除失败:', error)
              this.$message.error('删除失败，请稍后重试')
            })
            .finally(() => {
              this.loading = false
            })
        })
        .catch(() => {
          // 用户取消
        })
    },

    // 提交表单
    handleSubmit() {
      this.$refs.configForm.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const url = this.form.id ? '/dssh/config/update' : '/dssh/config/add'
          this.$http.post(url, this.form)
            .then(response => {
              if (response.data.code === 200) {
                this.$message.success(this.form.id ? '更新成功' : '添加成功')
                this.dialogVisible = false
                this.getList()
              } else {
                this.$message.error(response.data.msg || '操作失败')
              }
            })
            .catch(error => {
              console.error('操作失败:', error)
              this.$message.error('操作失败，请稍后重试')
            })
            .finally(() => {
              this.submitLoading = false
            })
        } else {
          this.$message.warning('请填写完整的表单信息')
          return false
        }
      })
    },

    // 对话框关闭
    handleDialogClose() {
      this.$refs.configForm.resetFields()
    }
  }
}
</script>

<style scoped>
.el-breadcrumb {
    width: 100%;
}
.el-table__row > td {
    border: none;
}
.el-table::before {
    height: 0px;
}
</style>
